"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var immutable_1 = require("immutable");
var rule_constants_1 = require("./rule-constants");
/** An action that changes a Form in some way */
var IFormAction = /** @class */ (function () {
    function IFormAction() {
    }
    return IFormAction;
}());
exports.IFormAction = IFormAction;
exports.defaultValues = {
    type: rule_constants_1.actionTypes.hide,
    elementId: '',
    value: undefined,
};
/** factory that generates immutable form actions */
exports.FormActionRecord = immutable_1.Record(exports.defaultValues);
/** immutable class that represents an [[IFormAction]] */
var ImmutableFormAction = /** @class */ (function (_super) {
    __extends(ImmutableFormAction, _super);
    function ImmutableFormAction(props) {
        return _super.call(this, props) || this;
    }
    return ImmutableFormAction;
}(exports.FormActionRecord));
exports.ImmutableFormAction = ImmutableFormAction;
//# sourceMappingURL=form-action.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@social-solutions/ssg-forms-processing/dist/form-definition/form-rules/form-action.js
// module id = 1116
// module chunks = 0